// eslint-disable-next-line import/no-extraneous-dependencies
import packageJson from 'tv/package.json';
import { v4 as uuid } from 'uuid';
import { CACHE_KEY } from '../../../constants/commonConstants';
import TvingLogModule from '../../tving-log-module/TvingLogModule';
import { DeviceModelName, PlatformName } from '../types';
/**
 * 웹 환경에서 장치 정보를 얻어올 수 없으므로 임시 정보를 띄우기 위한 디바이스 인터페이스
 */
var WebDeviceManager = /** @class */ (function () {
    function WebDeviceManager() {
        this.logger = TvingLogModule;
        this.platformId = PlatformName.web;
    }
    WebDeviceManager.prototype.init = function () {
        this.logger.info('[WebDeviceManager.init()]');
        return Promise.resolve();
    };
    WebDeviceManager.prototype.exit = function () {
        this.logger.info('[WebDeviceManager.exit()]');
    };
    WebDeviceManager.prototype.getDeviceInfo = function () {
        // this.logger.info('[WebDeviceManager.getDeviceInfo()]');
        var deviceUuid = localStorage.getItem(CACHE_KEY.uuid);
        if (!deviceUuid) {
            deviceUuid = encodeURIComponent(uuid());
            localStorage.setItem(CACHE_KEY.uuid, deviceUuid);
        }
        return {
            osVersion: 'web',
            platformOs: "".concat(this.platformId, " 0.0.0"),
            appVersion: '0.0.0',
            appWebVersion: "0.0.0_".concat(packageJson.version),
            deviceModel: DeviceModelName.web,
            resolutionWidth: 1920,
            resolutionHeight: 1080,
            uuid: deviceUuid,
        };
    };
    WebDeviceManager.prototype.deeplink = function () {
        this.logger.info('[WebDeviceManager.deeplink()]');
    };
    WebDeviceManager.prototype.twoDepth = function () {
        this.logger.info('[WebDeviceManager.twoDepth()]');
    };
    return WebDeviceManager;
}());
export default WebDeviceManager;
